import { Component, HostListener, computed, input, output } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-pergunta-modal',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './pergunta-modal.component.html',
  styleUrl: './pergunta-modal.component.scss',
})
export class PerguntaModalComponent {
  readonly perguntaGroup = input.required<FormGroup>();
  readonly modo = input.required<'editar' | 'visualizar'>();
  readonly indice = input.required<number>();

  readonly adicionarAlternativa = output<void>();
  readonly removerAlternativa = output<number>();
  readonly fechar = output<void>();

  readonly somenteLeitura = computed(() => this.modo() === 'visualizar');
  readonly titulo = computed(() =>
    this.modo() === 'visualizar' ? 'Visualizar pergunta' : 'Editar pergunta',
  );

  get alternativas(): FormArray {
    return this.perguntaGroup().get('alternativas') as FormArray;
  }

  // Removido por decisão do PO — peso removido, ver plano
  // 2026-08-11-questionario-erro-exclusao-e-remove-peso.
  // get pesoIncoerenteMensagem(): string | null {
  //   const pesoIncoerente = this.perguntaGroup().errors?.['pesoIncoerente'];
  //   if (!pesoIncoerente) return null;
  //   return `Peso deve ser igual à soma dos pontos das opções (${pesoIncoerente.esperado})`;
  // }

  get alternativasInsuficientesMensagem(): string | null {
    return this.alternativas.errors?.['minlength'] ? 'A pergunta precisa de pelo menos 2 alternativas.' : null;
  }

  /**
   * O "Incluir" só confirma a pergunta quando ela está completa: enunciado e
   * todas as alternativas com texto e pontos válidos. Sem isso a pergunta
   * entrava na lista pela metade e travava o salvamento depois.
   */
  get motivoIncluirDesabilitado(): string | null {
    if (this.perguntaGroup().valid) return null;

    if (this.perguntaGroup().get('texto')?.invalid) return 'Informe o enunciado da pergunta.';
    if (this.alternativasInsuficientesMensagem) return this.alternativasInsuficientesMensagem;

    const alternativaIncompleta = this.alternativas.controls.findIndex((grupo) => grupo.invalid);
    if (alternativaIncompleta >= 0) {
      return `Complete a alternativa ${alternativaIncompleta + 1}: texto e pontos entre 0 e 9999.`;
    }

    return null;
  }

  alternativaPontosErro(altGroup: FormGroup): string | null {
    const pontos = altGroup.get('pontos');
    if (!pontos || pontos.valid || !pontos.touched) return null;

    if (pontos.errors?.['required']) return 'Informe os pontos.';
    if (pontos.errors?.['min']) return 'Mínimo de 0 pontos.';
    if (pontos.errors?.['max']) return 'Máximo de 9999 pontos.';
    return null;
  }

  /**
   * Em visualização, alternativas nunca preenchidas (placeholders da criação
   * rápida, que sempre nasce com 2 em branco) não devem aparecer como se a
   * pessoa tivesse cadastrado opções.
   */
  get alternativaGroups(): FormGroup[] {
    const groups = this.alternativas.controls as FormGroup[];

    if (!this.somenteLeitura()) {
      return groups;
    }

    return groups.filter((group) => (group.value.texto ?? '').toString().trim() !== '');
  }

  onFechar(): void {
    this.fechar.emit();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.onFechar();
  }
}
